/* import __COLOCATED_TEMPLATE__ from './lsg-search.hbs'; */
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';

/**
 * Search component will show the 'search' materialize icon and will allow toggling to a search input
 */
export default Component.extend({
  /**
   * HTML Properties
   */
  tagName: 'div',
  classNames: ['LSG-c-search'],
  classNameBindings: ['isSearchActivated:search-activated'],

  /**
   * Set this to true to activate the search mechanism (Show the text input)
   *
   * Passed by Reference.
   * @param {Boolean}
   */
  isSearchActivated: false,

  /**
   * The text to prompt the user when no input.
   *
   * @param {String}
   */
  placeholder: 'Type to search...',

  /**
   * Will be called when the search option is toggled.
   *
   * @param {Boolean} isActive    if toggle was activated or not.
   * @return {Function}
   */
  onSearchToggled: (isActive) => (function() {}),

  /**
   * The value the user has entered
   *
   * Passed by Reference.
   * @param {String}
   */
  searchInputValue: '',

  /**
   * @param {JQuery.Event} e
   */
  keyDown(e) {
    if (e.keyCode === 27 && this.get('isSearchActivated')) { //ESCAPE KEY
      this.set('isSearchActivated', false);
    }
  },

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * @param {String} text
     */
    onUpdateSearchText(text) {
      this.set('searchInputValue', text);
    },

    /**
     * Toggle whether or not the search input view is active.
     */
    toggleSearchActivated: function() {
      this.toggleProperty('isSearchActivated');

      if (this.get('isSearchActivated')) {
        scheduleOnce('afterRender', this, function() {
          this.element.querySelector('input').focus();
        });
      }

      this.get('onSearchToggled')(this.get('isSearchActivated'));
    }
  }
});
